import { render, staticRenderFns } from "./FullScreenLoader.vue?vue&type=template&id=36869ba2&scoped=true&"
import script from "./FullScreenLoader.vue?vue&type=script&lang=js&"
export * from "./FullScreenLoader.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenLoader.vue?vue&type=style&index=0&id=36869ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36869ba2",
  null
  
)

export default component.exports